import React from "react";
import { motion } from "framer-motion";

const TermsOfService = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-[#0B0F19] text-white min-h-screen font-sans selection:bg-cyan-500">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-black uppercase italic tracking-tighter mb-6 md:mb-8">
            Terms of <span className="text-cyan-400">Service</span>
          </h1>

          <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-8 md:mb-12">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <div className="space-y-8 md:space-y-12">
            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                1. Acceptance of Terms
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                By accessing or using our services, you agree to be bound by these
                Terms of Service. If you do not agree to these terms, please do
                not use our services.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                We reserve the right to modify these terms at any time. Your
                continued use of our services after such modifications constitutes
                your acceptance of the updated terms.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                2. Description of Service
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                Connected Business Solutions provides digital solutions,
                software development, and technology consulting services. Our
                services are designed to help businesses leverage technology for
                growth and efficiency.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                We reserve the right to modify, suspend, or discontinue any
                aspect of our services at any time without prior notice.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                3. User Responsibilities
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                You agree to use our services only for lawful purposes and in
                accordance with these Terms. You are responsible for maintaining
                the confidentiality of your account credentials.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                You agree not to use our services for any illegal or unauthorized
                purpose, including but not limited to violating any laws,
                regulations, or third-party rights.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                4. Intellectual Property
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                All content, features, and functionality of our services are owned
                by Connected Business Solutions and are protected by
                international copyright, trademark, and other intellectual
                property laws.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                You may not reproduce, distribute, modify, or create derivative
                works of any content from our services without our express written
                permission.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                5. Limitation of Liability
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                To the fullest extent permitted by law, Connected Business
                Solutions shall not be liable for any indirect, incidental,
                special, consequential, or punitive damages.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                Our total liability for any claims arising out of or relating to
                these terms or our services shall not exceed the amount you paid
                for the services, if any.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                6. Termination
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                We reserve the right to terminate or suspend your access to our
                services at any time, without prior notice, for any reason,
                including but not limited to breach of these Terms.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                Upon termination, your right to use the services will immediately
                cease. All provisions of these Terms shall survive termination.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.7 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                7. Governing Law
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                These Terms shall be governed by and construed in accordance with
                the laws of Myanmar, without regard to its conflict of law
                provisions.
              </p>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed">
                Any disputes arising under these Terms shall be subject to the
                exclusive jurisdiction of the courts of Myanmar.
              </p>
            </motion.section>

            <motion.section
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8 }}
              className="bg-[#161B22]/50 border border-white/5 rounded-2xl md:rounded-3xl p-6 md:p-8">
              <h2 className="text-xl md:text-2xl font-black uppercase italic tracking-tighter mb-4 text-white">
                8. Contact Us
              </h2>
              <p className="text-slate-400 text-sm md:text-base leading-relaxed mb-4">
                If you have any questions about these Terms of Service, please
                contact us at:
              </p>
              <div className="space-y-2">
                <p className="text-cyan-400 text-sm md:text-base font-medium">
                  Email: support@cbs.com.mm
                </p>
                <p className="text-cyan-400 text-sm md:text-base font-medium">
                  Address: Connected Business Solutions, Yangon, Myanmar
                </p>
              </div>
            </motion.section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;
